// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const messageBroadcast_confirmSend = (i) => `Do you really want to send the message to all guests?`